<template>
  <div class="blog-list-page">
    <section class="hero">
      <div class="container">
        <h1 class="title">{{ pageTitle }}</h1>
        <p class="subtitle">{{ pageSubtitle }}</p>
      </div>
    </section>
    <div class="container">
      <BlogBreadcrumb />
    </div>

    <section class="content">
      <div class="container">
        <BlogPostList :items="items" :empty-text="emptyText" :read-more-label="readMoreLabel" />
      </div>
      <div class="container">
        <BlogPagination
          :current-page="1"
          :total-pages="totalPages"
          :base-path="basePath"
          :prev-label="prevLabel"
          :next-label="nextLabel"
          :mobile-label="mobileLabel"
        />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import BlogPostList from '~/components/blog/BlogPostList.vue';
import BlogBreadcrumb from '~/components/blog/BlogBreadcrumb.vue';
import BlogPagination from '~/components/blog/BlogPagination.vue';
import { useBlogListPage } from '~/composables/useBlogListPage';

const {
  items,
  totalPages,
  pageTitle,
  pageSubtitle,
  emptyText,
  readMoreLabel,
  basePath,
  prevLabel,
  nextLabel,
  mobileLabel,
  seoConfig
} = await useBlogListPage(1);

useWebsiteSeo(seoConfig.value);
</script>

<style scoped lang="scss">
@use '~/assets/scss/pages/blog-list.scss';
</style>
